import { render, staticRenderFns } from "./TabsSlider.vue?vue&type=template&id=0fc3de0b&scoped=true&lang=pug"
import script from "./TabsSlider.vue?vue&type=script&lang=ts"
export * from "./TabsSlider.vue?vue&type=script&lang=ts"
import style0 from "./TabsSlider.vue?vue&type=style&index=0&id=0fc3de0b&prod&scoped=true&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fc3de0b",
  null
  
)

export default component.exports